export default __webpack_public_path__ + "static/media/c006-6.f3af771f.jpg";